import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import StaffEditTab from './Elements/StaffEditTab';
import StaffLicensesTab from './Elements/StaffLicensesTab';
import StaffRolesTab from './Elements/StaffRolesTab';
import StaffDesignationsTab from './Elements/StaffDesignationsTab';
import StaffPeriodsTab from './Elements/StaffPeriodsTab';
import StaffGratificationsTab from './Elements/StaffGratificationsTab';
import StaffIcaosTab from './Elements/StaffIcaosTab';
import StaffHoursTab from './Elements/StaffHoursTab';
import StaffClientsTab from './Elements/StaffClientsTab';
import StaffCertificationsTab from './Elements/StaffCertificationsTab';
import StaffIndicationsTab from './Elements/StaffIndicationsTab';
import StaffPaymentsTab from './Elements/StaffPaymentsTab';
import StaffVacationTab from './Elements/StaffVacationTab';
import StaffCertificationsTypeTab from './Elements/StaffCertificationsTypeTab';
import StaffRecordTab from './Elements/StaffRecordTab';
import StaffAdministrativeTab from './Elements/StaffAdministrativeTab';
import StaffProcessTab from './Elements/StaffProcessTab';
import StaffBasesTab from './Elements/StaffBasesTab';
import StaffCostsTab from './Elements/StaffCostsTab';
import StaffGuaranteedHoursTab from './Elements/StaffGuaranteedHoursTab';
import getLocale from '../../i18n/getLocale';


class StaffsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      staff_data: {},
      flight_hours_totals: null,
      staff_flight_files: null,
      aircraft_models: null,
      designations: null,
      staff_licenses: null,
      staff_roles: null,
      staff_designations: null,
      staff_gratifications: null,
      staff_indications: null,
      roles: null,
      syncingLogbook: false,
      syncButtonShake: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.export = this.export.bind(this);
    this.openAnac = this.openAnac.bind(this);
    this.archive = this.archive.bind(this);
    this.restauration = this.restauration.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.syncWithLogbook = this.syncWithLogbook.bind(this);
    this.handleSyncHint = this.handleSyncHint.bind(this);

    this.locale = getLocale();

    this.syncShakeTimeout = null;
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  componentWillUnmount () {
    if (this.syncShakeTimeout) {
      clearTimeout(this.syncShakeTimeout);
      this.syncShakeTimeout = null;
    }
  }

  handleSyncHint(payload = {}) {
    if (this.syncShakeTimeout) {
      clearTimeout(this.syncShakeTimeout);
      this.syncShakeTimeout = null;
    }

    this.setState(prevState => {
      const nextState = { syncButtonShake: true };
      const staffData = Object.assign({}, prevState.staff_data || {});
      if (payload && Object.prototype.hasOwnProperty.call(payload, 'logbook_external_id')) {
        staffData.logbook_external_id = payload.logbook_external_id;
      }
      nextState.staff_data = staffData;
      return nextState;
    }, () => {
      this.syncShakeTimeout = setTimeout(() => {
        this.setState({ syncButtonShake: false });
        this.syncShakeTimeout = null;
      }, 4000);
    });
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/lista/modelos';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aircraft_models: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/habilitacoes/ativas/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_licenses: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/cargos/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_roles: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/cargos/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({roles: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/designacoes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({designations: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/designacoes/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_designations: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/indicacoes/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_indications: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/horas/voos/totais/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({flight_hours_totals: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcionario/voos/arquivos/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_flight_files: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
     }); /* Lista de frotas */ }); /* Lista de habilitações do funcionário */ }); /* Lista de funções */ }); /* Lista de funções do funcionário */ }); /* Lista de designações do funcionário */ }); /* Lista de indicações do funcionário */ }); /* Lista de designações */ }); /* Lista de quinzenas do funcionário */}); /* Lista de gratificações do funcionário */ }); /* Lista de gratificações */ }); /* Lista de icaos do funcionário */
  }

  export(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  archive(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/demitir/funcionario/';
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshData(responseJson);
        }
      });
    });
  }

  restauration(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    var url = '/restaurar/funcionario/';
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.refreshData(responseJson);
        }
      });
    });
  }

  refreshData(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/funcionario/'+self.props.match.params.id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_data: responseJson.data});
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  syncWithLogbook(event) {
    event.preventDefault();

    if (this.state.syncingLogbook || !this.state.staff_data || !this.state.staff_data.id) {
      return;
    }

    this.handleAlert('', '', 'open');
    this.setState({ syncingLogbook: true, syncButtonShake: false });

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/sync/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify({ id: self.state.staff_data.id }) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var logbookId = responseJson.data && typeof responseJson.data.logbook_external_id !== 'undefined' ? responseJson.data.logbook_external_id : undefined;
          self.handleSyncHint({ logbook_external_id: logbookId });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      }).then(() => {
        self.setState({ syncingLogbook: false });
      });
    });
  }

  openAnac(url) {
    window.open(this.state.staff_data.url_anac);
  }

  render() {
    const syncButtonClass = `btn btn-warning logbook-sync-button${this.state.syncButtonShake ? ' logbook-sync-shake' : ''}`;
    const syncButtonIcon = this.state.syncingLogbook ? 'fa fa-spinner fa-pulse' : 'fa fa-refresh';
    const disableSync = this.state.syncingLogbook || !this.state.staff_data || !this.state.staff_data.id;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Tripulantes.EditarFuncionario.titulo} - {this.state.staff_data.name}</h3>
      <div className="grid-buttons pull-right logbook-sync-actions">
        <button type="button" className={syncButtonClass} onClick={this.syncWithLogbook} disabled={disableSync}>
          <i className={syncButtonIcon}></i>{' Sincronizar com o Logbook App'}
        </button>
        <Link to="/colaboradores" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
       {(this.state.staff_data.situation === 'Demitido') ?
          <button onClick={this.restauration} className="btn btn-success">
          <i className="fa fa-user"></i> {this.locale.Tripulantes.EditarFuncionario.botaoRestaurar}
          </button>
         :
          <button onClick={this.archive} className="btn btn-danger">
          <i className="fa fa-user"></i> {this.locale.Tripulantes.EditarFuncionario.botaoArquivoMorto}
          </button>
        }
      </div>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.Tripulantes.EditarFuncionario.tabDadosDoFuncionario.tituloTab}>
          <StaffEditTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_data={this.state.staff_data} onSyncHint={this.handleSyncHint} logbookExternalId={this.state.staff_data ? this.state.staff_data.logbook_external_id : null} />
        </Tab>
        <Tab eventKey={3} title={this.locale.Tripulantes.EditarFuncionario.tabHorasDeVoo.tituloTab}>
          <StaffHoursTab RequestApi={this.refs.request_api} handleAlert={this.handleAlert} staff_id={this.props.match.params.id} flight_hours_totals={this.state.flight_hours_totals} staff_flight_files={this.state.staff_flight_files} />
        </Tab>
        <Tab eventKey={4} title={this.locale.Tripulantes.EditarFuncionario.tabHabilitacoes.tituloTab}>
          <StaffLicensesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} aircraft_models={this.state.aircraft_models} staff_licenses={this.state.staff_licenses} />
        </Tab>
        <Tab eventKey={9} title={this.locale.Tripulantes.EditarFuncionario.tabCargos.tituloTab}>
          <StaffRolesTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_roles={this.state.staff_roles} roles={this.state.roles} />
        </Tab>
        <Tab eventKey={10} title={this.locale.Tripulantes.EditarFuncionario.tabDesignacoes.tituloTab}>
          <StaffDesignationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_designations={this.state.staff_designations} designations={this.state.designations} aircraft_models={this.state.aircraft_models} />
        </Tab>
        <Tab eventKey={11} title={this.locale.Tripulantes.EditarFuncionario.tabIndicacoes.tituloTab}>
          <StaffIndicationsTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_indications={this.state.staff_indications} designations={this.state.designations} aircraft_models={this.state.aircraft_models} />
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default StaffsEdit;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsEdit.js